const currencyFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const currencyFmtCents = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
})

const numberFmt = new Intl.NumberFormat('en-US')

const pctFmt = new Intl.NumberFormat('en-US', {
  style: 'percent',
  maximumFractionDigits: 1,
})

const dateFmt = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  timeZone: 'America/Los_Angeles',
})

const dateTimeFmt = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZone: 'America/Los_Angeles',
})

export function formatCurrency(cents: number | null | undefined): string {
  if (cents == null) return '—'
  return currencyFmt.format(cents / 100)
}

export function formatDollars(dollars: number | null | undefined): string {
  if (dollars == null) return '—'
  return currencyFmt.format(dollars)
}

export function formatDollarsCents(dollars: number | null | undefined): string {
  if (dollars == null) return '—'
  return currencyFmtCents.format(dollars)
}

export function formatNumber(n: number | null | undefined): string {
  if (n == null) return '—'
  return numberFmt.format(n)
}

export function formatPct(ratio: number | null | undefined): string {
  if (ratio == null) return '—'
  return pctFmt.format(ratio / 100)
}

export function formatPctRaw(ratio: number | null | undefined): string {
  if (ratio == null) return '—'
  return `${Number(ratio).toFixed(1)}%`
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (isNaN(d.getTime())) return '—'
  return dateFmt.format(d)
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (isNaN(d.getTime())) return '—'
  return dateTimeFmt.format(d)
}

export const COLUMN_LABELS: Record<string, string> = {
  event_id: 'Event ID',
  event_name: 'Event',
  start_at_utc: 'Start Date',
  end_at_utc: 'End Date',
  settlement_gross_cents: 'Gross Revenue',
  settlement_net_cents: 'Net Revenue',
  settlement_fees_cents: 'Fees',
  gross_cents: 'Gross Revenue',
  net_cents: 'Net Revenue',
  fees_cents: 'Fees',
  revenue_total: 'Revenue',
  ride_gross: 'Ride Revenue',
  guests: 'Guests',
  riders_per_hour: 'Riders/Hr',
  orders_per_hour: 'Orders/Hr',
  plan_name: 'Plan',
  orders: 'Orders',
  revenue: 'Revenue',
  pct_of_orders: '% of Orders',
  attraction_name: 'Attraction',
  attraction_type: 'Type',
  attraction_id: 'ID',
  total_scans: 'Total Scans',
  scans: 'Scans',
  unique_guests: 'Unique Guests',
  unique_bands: 'Unique Guests',
  repeat_play_pct: 'Repeat Play %',
  kiosk_group_name: 'Kiosk Group',
  placement_type: 'Placement',
  new_band_orders: 'New Bands',
  reload_orders: 'Reloads',
  rank: '#',
}

export function humanLabel(key: string): string {
  return COLUMN_LABELS[key] ?? key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

export function autoFormat(key: string, value: unknown): string {
  if (value == null) return '—'
  if (key.endsWith('_cents')) return formatCurrency(Number(value))
  if (key === 'revenue' || key === 'revenue_total' || key === 'ride_gross') return formatDollars(Number(value))
  if (key.endsWith('_utc') || key.endsWith('_at') || key === 'event_date') return formatDate(String(value))
  if (key === 'pct_of_orders' || key === 'repeat_play_pct') return formatPctRaw(Number(value))
  if (typeof value === 'number') return formatNumber(value)
  return String(value)
}
